module.exports = __webpack_public_path__ + "static/media/assinatura-digital.cb1f76dc.svg";